import { Button, Card, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Images } from "../../../../assets";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import styled from "styled-components";
import { useEffect } from "react";
import { Flex } from "antd";

const Inactive = ({ activate = () => {}, readMore = () => {} }) => {
  const { isConfigured, alarmSMS, updateProgress } = useViewModel();

  useEffect(() => {
    if (!alarmSMS.configured && isConfigured) {
      activate();
      updateProgress({ [Enums.serviceCardIDs.alarmSms]: false });
    }
  }, []);

  return (
    <Styled background={`url(${Images.alarmSmsInactiveCardBg})`}>
      <Text
        level={4}
        weight={700}
        type="tertiary"
        lineHeight="normal"
        children={Localization.general.alarmSMS}
      />
      <div className="desc">
        <Text
          weight={700}
          type="tertiary"
          className="m-30-t"
          children={Localization.service.alarmSMS_inactive_info_title}
        />
        <Text
          weight={400}
          type="tertiary"
          className="m-10-t"
          children={Localization.service.alarmSMS_inactive_info_desc}
        />
        <Text
          weight={700}
          type="tertiary"
          className="m-10-t"
          children={Localization.formatString(
            Localization.service.alarmSMS_inactive_info_subtitle_0,
            30
          )}
        />
      </div>
      <Flex className="m-30-t" gap={"1rem"}>
        <Button
          type="primary"
          color="tertiary"
          onClick={activate}
          title={Localization.general.activate}
        />
        <Button
          color="tertiary"
          onClick={readMore}
          title={Localization.general.read_more}
        />
      </Flex>
    </Styled>
  );
};

const Styled = styled(Card)`
  .desc {
    padding-right: 8.5rem;
    ${(_) => _.theme.mobile(`padding-right: 0;`)}
  }
`;

export default Inactive;
